import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { PropsOf } from 'app/tools/general.types';
import React, { Ref } from 'react';
import styled, { css } from 'styled-components/macro';
import { Merge } from 'type-fest';
import Button from '../components/button/Button';

const ButtonElement = styled(Button)`
  ${styledMixins.fullsize}
  .MuiButton-label > div {
    display: flex;
    ${styledMixins.fullsize}
    margin: 0;
    padding: ${styledFuncs.pad(0.5)};
  }
`;

type Props = Merge<
  PropsOf<typeof Button>,
  {
    wide?: boolean;
    noClickAction?: boolean;
    children: React.ReactNode;
  }
>;
function TileCardButton(
  { wide, noClickAction, children, color, ...p }: Props,
  ref: Ref<HTMLDivElement>
): JSX.Element {
  return (
    <ButtonElement
      plain
      asSpan
      disabled={noClickAction}
      color={color || 'default'}
      css={css`
        ${noClickAction && styledMixins.muiUnfadeDisabledButton}
      `}
      {...p}
    >
      {/* Let button color come through if set and not 'default' */}
      <div
        css={css`
          background: ${color && color !== 'default'
            ? 'transparent'
            : 'white'};
          ${styledMixins.roundCorners}
          ${styledMixins.softShadowSmall}
        `}
        {...{ ref }}
      >
        {children}
      </div>
    </ButtonElement>
  );
}
export default React.forwardRef(TileCardButton);
